import { baseDocSerializer } from "@megaron/resource";
import { Serializers, SerializerValue } from "@megaron/serializers";
import { uuidSerializer } from "@megaron/uuid";

import { itemVariantSerializer } from "./items";

export const itemDocSerializer = Serializers.object({
  ...baseDocSerializer("item").fields,

  itemId: Serializers.string,
  loyaltyId: Serializers.string.nullable(),
  productId: Serializers.string,
  itemName: Serializers.string,
  gtin: Serializers.string.nullable(),
  box: Serializers.integer.nullable(),
  layer: Serializers.integer.nullable(),
  pallet: Serializers.integer.nullable(),
  size: Serializers.decimal,
  sizeUnit: Serializers.string,
  massKg: Serializers.decimal,
  bcId: uuidSerializer.nullable(),
  productGroup: Serializers.string,
  title: Serializers.string,
  variant: itemVariantSerializer,
  brand: Serializers.string,
  description: Serializers.string,
  handle: Serializers.string.nullable(),
  shopifyVariantId: Serializers.string.nullable(),
  shopifyProductId: Serializers.string.nullable(),
  cost: Serializers.decimal.nullable(),
  isInAvailability: Serializers.boolean,
  coverageM2: Serializers.decimal.nullable(),
  currentPrices: Serializers.record(
    Serializers.object({
      currency: Serializers.string,
      price: Serializers.decimal,
    }),
    Serializers.string,
  ),
});

export type ItemDoc = SerializerValue<typeof itemDocSerializer>;
